import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 px-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-settings_profil_verwalten",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = { class: "row mx-auto" }
const _hoisted_6 = { class: "col-12 col-md-9 px-0" }
const _hoisted_7 = { class: "col-12 col-md-3 text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "h2-title mt-3" }
const _hoisted_10 = { class: "col-12 d-flex bg-lightblue p-3 kapazitaetrow mt-3" }
const _hoisted_11 = { class: "h2-title mt-3" }
const _hoisted_12 = { class: "col-12 d-flex align-items-start align-items-sm-center flex-column flex-sm-row bg-lightblue p-3 kapazitaetrow mt-3" }
const _hoisted_13 = { class: "ml-0 ml-sm-3" }
const _hoisted_14 = { class: "col-12 d-flex align-items-start align-items-sm-center flex-column flex-sm-row bg-lightblue p-3 kapazitaetrow mt-3" }
const _hoisted_15 = { class: "ml-0 ml-sm-3" }
const _hoisted_16 = { class: "row mx-auto mt-4" }
const _hoisted_17 = { class: "col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0" }
const _hoisted_18 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }
const _hoisted_19 = { class: "h2-title mt-4" }
const _hoisted_20 = { class: "col-12 d-flex align-items-center bg-danger-teres p-3 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_confirmation_message = _resolveComponent("confirmation-message")!
  const _component_control_input = _resolveComponent("control-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_room_image = _resolveComponent("room-image")!
  const _component_control_integer = _resolveComponent("control-integer")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_button_save = _resolveComponent("button-save")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.roomEdit.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/rooms",
      i18nMessage: "common.backToOverview",
      class: "mb-3"
    }),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/rooms"
    }, {
      default: _withCtx(() => [
        (_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createBlock(_component_confirmation_message, {
              key: 0,
              i18nMessage: "views.roomEdit.confirmDelete",
              i18nParams: [_ctx.name],
              confirmButtonType: "delete",
              onCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteConfirmation = false)),
              onConfirmed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteRoom()))
            }, null, 8, ["i18nParams"]))
          : _createCommentVNode("", true),
        (!_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_control_input, {
                    i18nLabel: "common.room.name",
                    validation: _ctx.v$.name,
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
                  }, null, 8, ["validation", "modelValue"]),
                  _createVNode(_component_control_input, {
                    i18nLabel: "common.room.description",
                    validation: _ctx.v$.description,
                    modelValue: _ctx.description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
                  }, null, 8, ["validation", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: { name: 'admin-room-edit-image', params: { id: _ctx.id }}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.room.editImage')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_8,
                  _createVNode(_component_room_image, {
                    room: _ctx.room,
                    class: "roomImageHeight mt-2"
                  }, null, 8, ["room"])
                ])
              ]),
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('common.room.capacity')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_control_integer, {
                  i18nLabel: "common.room.personCount",
                  validation: _ctx.v$.capacity,
                  modelValue: _ctx.capacity,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.capacity) = $event)),
                  showBreak: true,
                  class: "d-flex flex-wrap align-items-center mr-3"
                }, null, 8, ["validation", "modelValue"])
              ]),
              _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('common.room.reservationPeriod')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_control_integer, {
                  i18nLabel: "common.room.openStartValue",
                  validation: _ctx.v$.openStartValue,
                  modelValue: _ctx.openStartValue,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openStartValue) = $event)),
                  showBreak: true,
                  class: "d-flex flex-wrap align-items-center mr-3"
                }, null, 8, ["validation", "modelValue"]),
                _createVNode(_component_control_select, {
                  i18nLabel: "common.room.openStartType",
                  validation: _ctx.v$.openStartType,
                  labelHidden: true,
                  modelValue: _ctx.openStartType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openStartType) = $event)),
                  availableValues: _ctx.selectOptions()
                }, null, 8, ["validation", "modelValue", "availableValues"]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('common.room.additionalStartEndInfo')), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_control_integer, {
                  i18nLabel: "common.room.openEndValue",
                  validation: _ctx.v$.openEndValue,
                  modelValue: _ctx.openEndValue,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openEndValue) = $event)),
                  showBreak: true,
                  class: "d-flex flex-wrap align-items-center mr-3"
                }, null, 8, ["validation", "modelValue"]),
                _createVNode(_component_control_select, {
                  i18nLabel: "common.room.openEndType",
                  validation: _ctx.v$.openEndType,
                  labelHidden: true,
                  modelValue: _ctx.openEndType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openEndType) = $event)),
                  availableValues: _ctx.selectOptions()
                }, null, 8, ["validation", "modelValue", "availableValues"]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('common.room.additionalStartEndInfo')), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_button_cancel, {
                    to: "/rooms",
                    class: "btn-w-100"
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_button_save, {
                    i18nMessage: "views.roomEdit.save",
                    class: "btn-w-100"
                  })
                ])
              ]),
              _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t('common.room.delete')), 1),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.reservationCount !== 0)
                  ? (_openBlock(), _createBlock(_component_feedback_message, {
                      key: 0,
                      message: _ctx.$t('common.room.notDeletable', { count: _ctx.reservationCount })
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                (_ctx.reservationCount === 0)
                  ? (_openBlock(), _createBlock(_component_button_delete, {
                      key: 1,
                      i18nMessage: "common.room.delete",
                      onClicked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteConfirmation = true))
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}